
<div
  class="cmp-order-stepper row justify-center full-width ws-typography relative-position cy-sticky"
  :style="stepperStyle"
  :class="{ backdropped: editBackdropActive }"
>
  <div class="container full-width">
    <div class="row justify-between no-wrap ws-invisible-scrollbar">
      <div
        v-for="(step, index) in visibleSteps"
        :key="step"
        class="col col-auto ellipsis text-center"
      >
        <a
          class="nav-link composite-text ws-typo-button-sm"
          :class="{ enabled: stepEnabled(step) }"
          :disabled="!stepEnabled(step)"
          href="javascript:void(0)"
          @click="stepEnabled(step) && navigateToStep(step, false)"
        >{{ index + 1 }}. {{ $t(getKey(step)) }}</a>

        <div class="progress-wrap q-mt-xs q-mx-auto">
          <div
            class="progress"
            :style="'width: ' + progressByUser[step] + '%'"
          ></div>
          <div
            class="rest"
            :style="'width: ' + (100 - progressByUser[step]) + '%'"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
